/**
 *
 * NotesLanding
 *
 */

import { mapState, mapMutations } from 'vuex';
import Swal from 'sweetalert2';

import { DOWNLOAD_NOTE_RFT } from '@/constants/api';

export const NotesDownloadMixin = {
  name: 'NotesDownloadMixin',

  data: () => {
    return {
      req: null,
    };
  },

  computed: {
    ...mapState('Notes', {
      ms_isGeneratingPdf: 'isGeneratingPdf',
    }),

    //
    c_selectedCourseForDownload() {
      // return {};
    },

    //
    c_strSelectedBookIdsForDownload() {
      // return '';
    },

    c_downloadAddress() {
      let url = DOWNLOAD_NOTE_RFT + this.c_selectedCourseForDownload.courseId;
      if (this.c_strSelectedBookIdsForDownload) {
        url += `?bookIds=${this.c_strSelectedBookIdsForDownload}`;
      }
      return url;
    },

    c_downloadFilename() {
      return `${this.c_selectedCourseForDownload.courseName}.pdf`;
    },
  },

  methods: {
    ...mapMutations('Notes', {
      mm_setIsGeneratingPdf: 'setIsGeneratingPdf',
    }),

    doGenerateFileRft() {
      //await this.ma_generateFileRft({
      //  course_id: this.c_currentCourse.course_id,
      //  bookIds: this.c_strSelectedBookIdsForDownload
      //});
      this.mm_setIsGeneratingPdf(true);
      this.req = new XMLHttpRequest();
      this.req.open('GET', this.c_downloadAddress, true);
      this.req.responseType = 'blob';
      const downloadFilename = this.c_downloadFilename;
      this.req.onload = (/* event */) => {
        let blob = this.req.response;
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = downloadFilename;
        link.click();
        this.mm_setIsGeneratingPdf(false);
      };
      this.req.send();
      Swal.fire({
        width: '400px',
        backdrop: false,
        type: 'success',
        icon: 'success',
        title: '开始处理',
        text: '稍后会自动下载文件，请耐心等待！',
        showConfirmButton: true,
        timer: 10000,
      });
    },

    generateFileRft() {
      this.doGenerateFileRft();
    },
  },
};
